import {invokeApi} from "../bl_libs/invokeApi";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";


export const submitContactUsRequest = async (name, email, message) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/pdq3/misc/contact_us',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        name,
        email,
        message
    };
    return invokeApi(requestObj);
}